module.exports = __webpack_public_path__ + "static/media/download.2f83459d.svg";